import { FormInstance } from "antd";
import * as dc from "@/components/layout/list/defaultType";
import { DataColumnField, DataColumnRecord } from "../input/inputType";
import { RefObject } from "react";
import { getInputValueCheck, runFormFunction, setFormClass } from "../input/inputFunction";
import { Debug } from "@/util/debug";
import { getTranslate } from "@/util/arrayutil";
import { AlertProps, TransitionType } from "../layoutType";

const cupnotePointCommon = (formFunction: Record<string, Record<string, Function>> | undefined, useShow?: boolean): DataColumnField => {
  return {
    ...dc.rateInput,
    itemClassName: useShow ? "satis_detail" : undefined,
    nullValue: 0,
    minValue: 1,
    read: {
      itemClassName: useShow ? "satis_detail animate-fade-right" : undefined,
    },
    create: { defaultValue: 10 },
    onChange: (e) => {
      Debug(e);
      runFormFunction(formFunction, "cupnote_radar", "changeData");
    },
  };
};
export const cupnoteListCommon: DataColumnField = {
  ...dc.selectSearchMulti,
  //itemClassName: "satis_detail",
  inputClassName: dc.inputCountryClassName,
  read: { display: "notNull" },
  edit: { codeGroupLabel: "feat" },
  selectPropOption: { reloadButtonClassName: "min-w-[2rem]" },
  maxLength: 500,
  showCount: true,
};
export const qcCommonInit = (
  data: any,
  form: FormInstance<any> | undefined,
  formMemo: Record<string, any> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  dataFunction: Record<string, Function> | undefined,
) => {
  Debug("qcCommonInit", data);
  const satis_detail = getInputValueCheck(form, formMemo, dataFunction, data, "cupnote_satis_detail");
  // const functionMode = satis_detail ? "addFormClass" : "removeFormClass";
  // if (dataFunction && dataFunction[functionMode]) {
  //   dataFunction[functionMode]("satis_detail_use");
  // }

  // runFormFunction(formFunction?.current, "cupnote_flavor_wheel", "changeData");
  setTimeout(() => {
    setFormClass(dataFunction, { satis_detail_use: satis_detail });
    const objs = document.querySelectorAll("form.ant-form .rt-Flex.data-chart.FlavorWheel svg > g > g");
    if (objs && objs.length > 0) {
      runFormFunction(formFunction, "cupnote_flavor_wheel", "changeData");
      const rotate = getInputValueCheck(form, formMemo, dataFunction, data, "cupnote_flavor_wheel_rotate") ?? 0;
      Debug("qcCommonInit", rotate);
      const objs = document.querySelectorAll("form.ant-form .rt-Flex.data-chart.FlavorWheel svg > g > g");
      objs.forEach((g) => {
        const obj = g as SVGGElement;
        const ctm = getTranslate(obj);
        if (ctm) {
          obj.setAttribute("transform", `translate(${ctm.x}, ${ctm.y}) rotate(${rotate})`);
        }
      });
    }
  }, dc.setTimeoutDelay);
};
export const qcRadar = (
  formFunction: Record<string, Record<string, Function>> | undefined,
  indexLabelKey: string | string[],
  iconName?: string | undefined,
  useShow?: boolean,
): DataColumnRecord => {
  return {
    cupnote_radar: {
      ...dc.cupRadar,
      read: {
        itemClassName: useShow ? "satis_detail animate-fade-down" : undefined,
      },
      itemClassName: useShow ? "satis_detail" : undefined,
      valueClassName: "justify-center lg:justify-start",
      inputType: "radarRate",
      readInput: false,
      readInputDisabled: false,
      noItem: false,
      disabled: false,
      readOnly: false,
      //fieldId: "greenbean_roaster_seq",
      indexKey: ["point"],
      indexLabelKey: indexLabelKey,
      imageDownload: "TasteProfile",
      radarProp: {
        ...dc.cupRadar.radarProp,
      },
    },
    cupnote_balance_point: { ...cupnotePointCommon(formFunction, useShow), label: "Balance", iconName: iconName ?? "CoffeeBean" },
    cupnote_aroma_point: { ...cupnotePointCommon(formFunction, useShow), label: "Aroma", iconName: iconName ?? "CoffeeBean" },
    cupnote_sweetness_point: { ...cupnotePointCommon(formFunction, useShow), label: "Sweetness", iconName: iconName ?? "CoffeeBean" },
    cupnote_body_point: { ...cupnotePointCommon(formFunction, useShow), label: "Body", iconName: iconName ?? "CoffeeBean" },
    cupnote_flavor_point: { ...cupnotePointCommon(formFunction, useShow), label: "Flavor", iconName: iconName ?? "CoffeeBean" },
    cupnote_acidity_point: { ...cupnotePointCommon(formFunction, useShow), label: "Acidity", iconName: iconName ?? "CoffeeBean" },
  };
};
export const qcSatis = (
  form: RefObject<FormInstance<any> | undefined> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  dataFunction: Record<string, Function> | undefined,
  indexLabelKey: string | string[],
  iconName?: string | undefined,
  useShow?: boolean,
): DataColumnRecord => {
  return {
    cupnote_satis: {
      ...dc.rateInput,
      iconName: iconName ?? "CoffeeBean",
      read: { variant: undefined, display: "notNull" },
      minValue: 1,
      create: { defaultValue: 10 },
      nullValue: 0,
      // required: true,
    },
    cupnote_satis_button: {
      label: "cupnote_satis_detail",
      itemClassName: "blending_info",
      read: { display: false },
      fieldId: {
        cupnote_satis_detail: {
          ...dc.use,
          read: { display: false },
          create: { defaultValue: false },
          onChange: (e: any) => {
            Debug(e);
            if (e.value) {
              if (dataFunction && dataFunction["addFormClass"]) {
                dataFunction["addFormClass"]("satis_detail_use");
              }
            } else {
              if (dataFunction && dataFunction["removeFormClass"]) {
                dataFunction["removeFormClass"]("satis_detail_use");
              }
            }
          },
        },
        cupnote_satis_clean: {
          ...dc.textButton("Broom", "cupnote_satis_clean", () => {
            const resetValues: Record<string, any> = {};
            const defaultValue = form?.current?.getFieldValue("cupnote_satis") ?? 5;
            const point_list = [
              "cupnote_balance_point",
              "cupnote_aroma_point",
              "cupnote_sweetness_point",
              "cupnote_body_point",
              "cupnote_flavor_point",
              "cupnote_acidity_point",
            ];
            point_list.forEach((item) => (resetValues[item] = defaultValue));
            ["cupnote_flavor_list", "cupnote_aftertaste_list", "cupnote_texture_list", "cupnote_feeling_list"].forEach(
              (item) => (resetValues[item] = undefined),
            );
            form?.current?.setFieldsValue({
              ...resetValues,
              cupnote_flavor_wheel_use: false,
              cupnote_flavor_wheel_simple: true,
              cupnote_flavor_wheel_rotate: 0,
            });
            [...point_list, "cupnote_flavor_wheel_rotate"].forEach((item) => runFormFunction(formFunction, item, "inputSync"));
            const objs = document.querySelectorAll("form.ant-form .rt-Flex.data-chart.FlavorWheel svg > g > g");
            const rotate = 0;
            objs.forEach((g) => {
              const obj = g as SVGGElement;
              const ctm = getTranslate(obj);
              if (ctm) {
                obj.setAttribute("transform", `translate(${ctm.x}, ${ctm.y}) rotate(${rotate})`);
              }
            });

            runFormFunction(formFunction, "cupnote_flavor_wheel", "changeData");
            runFormFunction(formFunction, "cupnote_radar", "changeData");
            setTimeout(() => {
              form?.current?.setFieldValue("cupnote_flavor_wheel_simple", false);
            }, dc.setTimeoutDelay);
          }),
          read: { display: false },
        },
      },
    },
    cupnote_satis_detail_guide: {
      ...dc.guideDefault,
      itemClassName: "blending_info " + dc.guideDefault.itemClassName,
      fixedValue: "cupnote_satis_detail_guide",
      read: { display: false },
    },
    ...qcRadar(formFunction, indexLabelKey, iconName, useShow),
  };
};
export const qcFlavorwheelChart: DataColumnRecord = {
  cupnote_flavor_wheel: {
    ...dc.flavorWheel,
    itemClassName: "cupnote_flavor_wheel_item",
    valueClassName: "justify-center lg:justify-start",
    codeGroup: "FLVR",
    imageDownload: "CoffeeFlavorWheel",
    flavorWheelProp: {
      target: "cupnote_flavor_list",
      checkReverse: "cupnote_flavor_wheel_reverse",
      showSimple: "cupnote_flavor_wheel_simple",
      wheelRotate: "cupnote_flavor_wheel_rotate",
      // transitionMode: "centerRadius",
    },
    read: { display: "true", displayCheckIds: ["cupnote_flavor_wheel_use"] },
    onChange: () => {},
  },
  cupnote_flavor_wheel_guide: {
    ...dc.guideDefault,
    fixedValue: "cupnote_flavor_wheel_guide",
    itemClassName: "cupnote_flavor_wheel_item " + dc.guideFull.itemClassName,
    read: { display: false },
  },
};
export const qcFlavorwheelReverse = (formFunction: Record<string, Record<string, Function>> | undefined): DataColumnRecord => {
  return {
    cupnote_flavor_wheel_reverse: {
      ...dc.use,
      read: { display: false },
      create: { defaultValue: false },
      onChange: () => {
        runFormFunction(formFunction, "cupnote_flavor_wheel", "changeData");
      },
    },
  };
};
export const qcFlavorwheelSimple = (formFunction: Record<string, Record<string, Function>> | undefined): DataColumnRecord => {
  return {
    cupnote_flavor_wheel_simple: {
      ...dc.use,
      itemClassName: "cupnote_flavor_wheel_item",
      // read: { display: false },
      read: { display: "true", displayCheckIds: ["cupnote_flavor_wheel_use"], inputClassName: dc.use.read?.inputClassName },
      noItem: false,
      readInputDisabled: false,
      create: { defaultValue: false },
      onChange: (e) => {
        Debug(e);
        runFormFunction(formFunction, "cupnote_flavor_wheel", "changeData");
        if (!e.value) {
          Debug("cupnote_flavor_wheel_simple setLoading", e);
          runFormFunction(formFunction, "cupnote_flavor_wheel", "setLoading", true);
          setTimeout(() => {
            const check = runFormFunction(formFunction, "cupnote_flavor_wheel", "getLoading");
            if (check.result) {
              runFormFunction(formFunction, "cupnote_flavor_wheel", "setLoading", false);
            }
          }, dc.setTimeoutDelay * 5);
        }
      },
      // edit: {},
    },
  };
};
export const qcFlavorwheelRotate = (alertContext: AlertProps | undefined, ta: TransitionType): DataColumnRecord => {
  return {
    cupnote_flavor_wheel_rotate: {
      label: "blank",
      // AppDownloadBlank() ? "blank" : {
      //   element: Capacitor.isNativePlatform() ? "share_image" : "download_image",
      //   elementType: "button",
      //   transition: true,
      //   buttonProp: {
      //     onClick: () => {
      //       exportElementAsPNGDefault(ta, alertContext, "form.ant-form .rt-Flex.data-chart.FlavorWheel", "FlavorWheel", undefined);
      //     },
      //   },
      // },

      ...dc.sliderInput,
      // inputClassName: dc.inputCountryClassName,
      // read: { itemClassName: "hidden" },
      itemClassName: "cupnote_flavor_wheel_item",
      inputClassName: "w-[20rem]",
      inputNumberClassName: "ml-4 max-h-[2rem]",
      minValue: -180,
      maxValue: 180,
      scale: 10,
      defaultValue: 0,
      unit: "°",
      // edit: { display: false },
      sliderProp: {
        included: false,
        marks: {
          "-180": "-180°",
          "-135": "-135°",
          "-90": "-90°",
          "-45": "-45°",
          0: { label: "0°", style: { marginLeft: "3.5px" } },
          45: "45°",
          90: "90°",
          135: "135°",
          180: { label: "180°", style: { width: "35px" } },
        },
        valueMark: "O",
        valueStyle: { top: "-35px" },
        valueOverride: true,
      },
      read: {
        // label: "blank",
        inputNumberClassName: "hidden",
        display: "true",
        displayCheckIds: ["cupnote_flavor_wheel_use"],
        sliderProp: {
          included: false,
          marks: {
            "-180": "-180°",
            "-90": "-90°",
            0: { label: "0°", style: { marginLeft: "3.5px" } },
            90: "90°",
            180: { label: "180°", style: { width: "35px" } },
          },
          valueMark: "O",
          valueStyle: { top: "-35px" },
          valueOverride: true,
        },
      },
      noItem: false,
      readInput: true,
      readInputDisabled: false,
      onChange: (e) => {
        const objs = document.querySelectorAll("form.ant-form .rt-Flex.data-chart.FlavorWheel svg > g > g");
        const rotate = e.value ?? 0;
        objs.forEach((g) => {
          const obj = g as SVGGElement;
          const ctm = getTranslate(obj);
          if (ctm) {
            obj.setAttribute("transform", `translate(${ctm.x}, ${ctm.y}) rotate(${rotate})`);
          }
        });
      },
    },
  };
};
export const qcFlavorwheelUser = (
  formFunction: Record<string, Record<string, Function>> | undefined,
  alertContext: AlertProps | undefined,
  ta: TransitionType,
): DataColumnRecord => {
  return {};
};
export const qcFlavorwheelSet = (
  formFunction: Record<string, Record<string, Function>> | undefined,
  alertContext: AlertProps | undefined,
  ta: TransitionType,
): DataColumnRecord => {
  return {
    ...qcFlavorwheelSimple(formFunction),
    ...qcFlavorwheelRotate(alertContext, ta),
    ...qcFlavorwheelChart,
  };
};
export const qcFlavorwheelList = (formFunction: Record<string, Record<string, Function>> | undefined): DataColumnField => {
  return {
    ...cupnoteListCommon,
    codeGroup: "FLVR",
    dataProp: {
      load: (data, value_data, field, index, change) => {
        if (!value_data) {
          runFormFunction(formFunction, "cupnote_flavor_wheel", "setLoading", true);
          runFormFunction(formFunction, "cupnote_flavor_wheel", "changeData");
          setTimeout(() => {
            const check = runFormFunction(formFunction, "cupnote_flavor_wheel", "getLoading");
            if (check.result) {
              runFormFunction(formFunction, "cupnote_flavor_wheel", "setLoading", false);
            }
          }, dc.setTimeoutDelay * 3);
        } else {
          runFormFunction(formFunction, "cupnote_flavor_wheel", "changeData");
        }
      },
    },
    onChange: () => {
      runFormFunction(formFunction, "cupnote_flavor_wheel", "changeData");
    },
  };
};
export const qcCommonCols = (
  form: RefObject<FormInstance<any> | undefined> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  dataFunction: Record<string, Function> | undefined,
  locale: string | undefined,
  indexLabelKey: string | string[],
  alertContext: AlertProps | undefined,
  ta: TransitionType,
  iconName?: string | undefined,
): DataColumnRecord => {
  return {
    div_qc_1: { ...dc.itemDiv, itemClassName: dc.itemDiv.itemClassName + " satis_detail" },
    ...qcSatis(form, formFunction, dataFunction, indexLabelKey, iconName, true),
    div_qc_2: {
      ...dc.itemDiv,
      itemClassName: dc.itemDiv.itemClassName + " blending_info",
      read: { display: "true", displayCheckIds: ["cupnote_flavor_wheel_use"] },
    },
    cupnote_flavor_wheel_use: {
      ...dc.use,
      itemClassName: "blending_info",
      read: { display: false },
      create: { defaultValue: false },
      onChange: (e) => {
        setFormClass(dataFunction, { hidden_cupnote_flavor_wheel: !e.value });
      },
    },
    ...qcFlavorwheelSet(formFunction, alertContext, ta),
    cupnote_flavor_list: { ...qcFlavorwheelList(formFunction), itemClassName: "blending_info", selectProp: { mode: "tags" } },
    cupnote_etc_list: {
      ...cupnoteListCommon,
      itemClassName: "blending_info",
      valueList: [],
      selectProp: { mode: "tags" },
      read: { label: "blank", labelClassName: dc.mobileHidden, display: "notNull" },
    },
    cupnote_aftertaste_list: { ...cupnoteListCommon, itemClassName: "blending_info", codeGroup: "CNAFTST" },
    cupnote_texture_list: { ...cupnoteListCommon, itemClassName: "blending_info", codeGroup: "CNTXTR" },
    cupnote_feeling_list: { ...cupnoteListCommon, itemClassName: "blending_info", codeGroup: "CNFLNG" },

    cupnote_desc: {
      ...dc.textAreaU,
      maxLength: 10000,
      showCount: true,
      read: { display: "notNull", labelUse: false, valueStyle: { gridColumn: "1 / span 2" } },
    },
  };
};
